import { render } from "./index.vue?vue&type=template&id=f65b67ee"
const script = {}

import exportComponent from "/home/gitlab-runner/builds/91znxra3/0/cs/cs-manager-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__